import React from 'react'
import * as UI from 'ui'
import * as Fields from 'support/fields'
import { Repeater } from 'support/fields'
import { Translation } from '@morningtrain/react-translations'
import { Fieldset } from 'layouts'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'

export default function SalaryStepsFields ({ cols = 2 }) {
  return (
    <Fieldset label={<Translation name='titles.salary_steps'/>}>
      <div className='form-element -mt-11'>
        <Repeater
          name='salary_steps' draggable={false}
          buttonClass='btn btn-sq btn-primary'
          addLabel={<UI.Icons.Plus className='w-3 h-3'/>}
          removeLabel={<UI.Icons.Trash className='w-4 h-4'/>}
          label={false}
        >
          <Fields.Hidden name='id'/>
          <Fieldset cols={cols}>
            <UpdateModelOnChange name='has_manual_salary_step_change' value={true}>
              <Fields.Select
                enum='salary_period_offset'
                name='salary_period_offset'
                label={<Translation name='fields.salary_period_offset.label'/>}
              />
            </UpdateModelOnChange>
            <UpdateModelOnChange name='has_manual_salary_step_change' value={true}>
              <Fields.TabsField
                enum='salary_type'
                name='type'
                label={<Translation name='fields.salary_type.label'/>}
                defaultValue='hourly'
              />
            </UpdateModelOnChange>
            <UpdateModelOnChange name='has_manual_salary_step_change' value={true}>
              <Fields.Number
                name='amount'
                label={<Translation name='fields.salary_amount.label'/>}
              />
            </UpdateModelOnChange>
          </Fieldset>
        </Repeater>
      </div>
    </Fieldset>
  )
}
